import Alert from "./components/Alert";
import "./StartScreen.css";
import { useRef } from "react";

export default function StartScreen({ onStartQuiz, isLoading }) {
  const alertRef = useRef(null);

  const copyLink = async () => {
    try {
      const textToCopy = window.location.href;
      await navigator.clipboard.writeText(textToCopy);
      if (alertRef.current) {
        alertRef.current.showAlert("Link copied!");
      }
    } catch (err) {
      console.error("Failed to copy link: ", err);
      alert("Failed to copy link. Please try again or copy manually.");
    }
  };

  return (
    <div className="start-screen-container">
      <div className="quiz-card">
        <div className="quiz-logo">
          <img src="/assets/images/logo-black.png" alt="Quiz Logo" className="quiz-logo-image" />
        </div>
        <h1 className="quiz-heading">Which GLP-1 Medication Is Right For You? Take The Science-Based Quiz Now.</h1>
        <button onClick={copyLink} className="quiz-button share-quiz-button">
          Share this quiz
        </button>
        <button onClick={onStartQuiz} className="quiz-button">

          {isLoading ? "Loading…" : "Start Quiz Now!"}
        </button>
      </div>
      <img src="/assets/images/landing-page-image-2.png" alt="Landing Page" className="landing-page-image" />
      <Alert ref={alertRef} />

    </div>
  );
}
